























































import {
  defineComponent,
  onBeforeMount,
  computed,
  ref,
} from "@vue/composition-api"
import { BookingState } from "@/app/models/booking-state"
import { useFindOneBooking } from "@/app/reactive/booking"
import Address from "@/app/components/facility/Address.vue"
import FacilityControls from "@/app/components/facility/FacilityControls.vue"
import BookingStarted from "@/app/components/booking/BookingStarted.vue"
import BookingReserved from "@/app/components/booking/BookingReserved.vue"
import BookingRecentlyPaid from "@/app/components/booking/BookingRecentlyPaid.vue"
import Carousel from "@/app/components/facility/Carousel.vue"

import Subtitle from "@/app/components/common/Subtitle.vue"
import Content from "@/app/components/common/Content.vue"
import Hint from "@/app/components/common/Hint.vue"
import Prices from "@/app/components/facility/Prices.vue"

import { useFindOneFacility } from "../reactive/facility"

export default defineComponent({
  name: "BookingWebview",
  components: {
    Address,
    Subtitle,
    Content,
    Hint,
    Prices,
    FacilityControls,
    BookingStarted,
    BookingReserved,
    BookingRecentlyPaid,
    Carousel,
  },
  setup(props, { root }) {
    const {
      facility,
      isFacilityPending,
      findOneFacility,
    } = useFindOneFacility()

    const { booking, isBookingPending, findOneBooking } = useFindOneBooking()

    const bookingStarted = ref<boolean>(false)
    const bookingReserved = ref<boolean>(false)

    const isPending = computed(
      () => isBookingPending.value || isFacilityPending.value,
    )

    const hasSuccessGateSnackbar = ref(false)
    const hasErrorGateSnackbar = ref(false)
    const hasWaitToTryAgainSnackbar = ref(false)

    onBeforeMount(async () => {
      // Find the booking
      const response = await findOneBooking(root.$route.params.referenceId)
      await findOneFacility(booking.value.facilityId)

      if (!response.wasSuccessful) {
        await root.$router.replace({ name: "not-found" })
      }
    })

    return {
      isPending,
      booking,
      bookingStarted,
      bookingReserved,
      facility,
      BookingState,
      hasErrorGateSnackbar,
      hasSuccessGateSnackbar,
      hasWaitToTryAgainSnackbar,
    }
  },
})
